import { useMemo } from 'react'
import { useQuery } from 'apollo-client'

import catalogueStructureQuery from './graph/catalogueStructure.graphql'
import type { CatalogueStructurePayload } from './graph/catalogueStructure.graphql'


type CataloguePayloadData = CatalogueStructurePayload['catalogue']['data']
type CatalogueBaseElements = CataloguePayloadData['children'][number]['children']
type CatalogueInputElements = Array<CatalogueBaseElements[number] | CataloguePayloadData['children'][number]>

const flatCatalogueStructure = (data: CatalogueInputElements): CatalogueBaseElements => {
  if (!data) {
    return null
  }

  return data.reduce((result, child) => {
    if ('children' in child) {
      const { children, ...element } = child

      result.push(element)
      result.push(...flatCatalogueStructure(children))
    }
    else {
      result.push(child)
    }

    return result
  }, [])
}

export type UseCatalogueStructureProps = {
  skip?: boolean
}

const useCatalogueStructure = ({ skip = false }: UseCatalogueStructureProps) => {
  const { data, isFetching } = useQuery(catalogueStructureQuery, {
    fetchPolicy: 'cache-first',
    skip,
    context: {
      ssrCache: true,
    },
  })

  // top level structure is object: {
  //   name: "Main"
  //   children: [
  //     { name: "subscription", children: [...] },
  //     { name: "shop", children: [...] }
  //   ],
  // }
  const structure = data?.catalogue?.data?.children
  const flatStructure = useMemo(() => flatCatalogueStructure(structure), [ structure ])

  return {
    structure,
    flatStructure,
    isFetching,
  }
}


export default useCatalogueStructure
